import { motion } from "framer-motion";
import { ROADMAP } from "../../lib/data";
import { Reveal, Overline, Icon } from "../ui-kit";

export default function Roadmap() {
  return (
    <section className="relative py-24 md:py-32 bg-[#080808] noise" data-testid="roadmap-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal className="max-w-2xl mb-16">
          <Overline index="06">Future Roadmap</Overline>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight text-white">
            The Road <span className="text-orange-500">Ahead</span>
          </h2>
        </Reveal>

        <div className="relative">
          {/* Connecting line */}
          <div className="hidden lg:block absolute top-6 left-0 right-0 h-px bg-gradient-to-r from-orange-500 via-zinc-700 to-transparent" />

          <div className="grid lg:grid-cols-3 gap-8">
            {ROADMAP.map((r, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.15 }}
                className="relative"
                data-testid={`roadmap-phase-${i}`}
              >
                <div className={`h-12 w-12 rounded-full flex items-center justify-center border-2 mb-6 ${
                  i === 0 ? "bg-orange-500 border-orange-500 text-black" : "bg-[#050505] border-zinc-700 text-zinc-500"
                }`}>
                  <Icon name={i === 0 ? "Zap" : i === 1 ? "Layers" : "Rocket"} size={22} />
                </div>
                <div className="flex items-baseline gap-3">
                  <h3 className="font-display text-2xl font-black uppercase text-white">{r.phase}</h3>
                  <span className={`text-xs font-bold uppercase tracking-widest ${i === 0 ? "text-orange-500" : "text-zinc-600"}`}>
                    {r.label}
                  </span>
                </div>
                <ul className="mt-5 space-y-3">
                  {r.items.map((it) => (
                    <li key={it} className="flex items-start gap-3 text-zinc-400">
                      <span className={`mt-1.5 h-1.5 w-1.5 shrink-0 ${i === 0 ? "bg-orange-500" : "bg-zinc-600"}`} />
                      <span className="text-sm">{it}</span>
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
